import store from 'client/store/store';
import { fetchSystemNoticesOnce } from 'client/store/systemMessageSlice/systemMessageSlice';

const loader = async () => {
    await store.dispatch(fetchSystemNoticesOnce());
};

export default loader;
